package br.com.vvrefeicoes.portal.feature.purchases

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.PrimaryScrollableTabRow
import androidx.compose.material3.PrimaryTabRow
import androidx.compose.material3.Surface
import androidx.compose.material3.Tab
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.di.LocalAppGraph
import br.com.vvrefeicoes.portal.core.ui.chart.NoGridStyle
import br.com.vvrefeicoes.portal.core.ui.components.AppBanner
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppFooter
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.layout.AppScrollColumn
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.core.ui.theme.AppShapes
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.MoneyFormatter
import br.com.vvrefeicoes.portal.core.util.MonthCalendar
import br.com.vvrefeicoes.portal.core.util.PercentFormatter
import br.com.vvrefeicoes.portal.core.util.PeriodMode
import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelCategory
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelData
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelMonthlyCost
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelMonthlyCount
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelProductUnitPriceChange
import br.com.vvrefeicoes.portal.domain.model.PurchasesType
import br.com.vvrefeicoes.portal.feature.operacional.ChartCard
import br.com.vvrefeicoes.portal.feature.operacional.HoverTooltip
import br.com.vvrefeicoes.portal.feature.operacional.LinePointLabel
import br.com.vvrefeicoes.portal.feature.operacional.PeriodSelector
import br.com.vvrefeicoes.portal.feature.operacional.ValueBar
import br.com.vvrefeicoes.portal.feature.operacional.compactMoney
import br.com.vvrefeicoes.portal.feature.operacional.rememberValueAxis
import com.composables.icons.lucide.Banknote
import com.composables.icons.lucide.Calendar
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.RefreshCw
import com.composables.icons.lucide.Scale
import com.composables.icons.lucide.ShoppingCart
import com.composables.icons.lucide.TrendingDown
import com.composables.icons.lucide.TrendingUp
import com.composables.icons.lucide.Users
import io.github.koalaplot.core.bar.DefaultBarPlotGroupedPointEntry
import io.github.koalaplot.core.bar.DefaultBarPosition
import io.github.koalaplot.core.bar.GroupedVerticalBarPlot
import io.github.koalaplot.core.bar.HorizontalBarPlot
import io.github.koalaplot.core.line.LinePlot
import io.github.koalaplot.core.style.LineStyle
import io.github.koalaplot.core.xygraph.CategoryAxisModel
import io.github.koalaplot.core.xygraph.Point
import io.github.koalaplot.core.xygraph.XYGraph
import io.github.koalaplot.core.xygraph.rememberAxisContent
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.compras_orders
import portalvv.shared.generated.resources.compras_panel_average_value
import portalvv.shared.generated.resources.compras_panel_axis_cost
import portalvv.shared.generated.resources.compras_panel_axis_orders
import portalvv.shared.generated.resources.compras_panel_category_total
import portalvv.shared.generated.resources.compras_panel_category_total_in
import portalvv.shared.generated.resources.compras_panel_chart_annual_cost
import portalvv.shared.generated.resources.compras_panel_chart_budget_actual
import portalvv.shared.generated.resources.compras_panel_chart_categories
import portalvv.shared.generated.resources.compras_panel_chart_extras_evolution
import portalvv.shared.generated.resources.compras_panel_economy
import portalvv.shared.generated.resources.compras_panel_empty
import portalvv.shared.generated.resources.compras_panel_extras_no_directorate
import portalvv.shared.generated.resources.compras_panel_extras_top_directorate
import portalvv.shared.generated.resources.compras_panel_extras_top_period
import portalvv.shared.generated.resources.compras_panel_extras_total
import portalvv.shared.generated.resources.compras_panel_extras_variation
import portalvv.shared.generated.resources.compras_panel_increase_month
import portalvv.shared.generated.resources.compras_panel_increase_period
import portalvv.shared.generated.resources.compras_panel_largest_increase
import portalvv.shared.generated.resources.compras_panel_largest_reduction
import portalvv.shared.generated.resources.compras_panel_month_highest_spend
import portalvv.shared.generated.resources.compras_panel_month_highest_variation
import portalvv.shared.generated.resources.compras_panel_month_lowest_spend
import portalvv.shared.generated.resources.compras_panel_month_lowest_variation
import portalvv.shared.generated.resources.compras_panel_monthly_average
import portalvv.shared.generated.resources.compras_panel_months_with_savings
import portalvv.shared.generated.resources.compras_panel_no_data
import portalvv.shared.generated.resources.compras_panel_no_increase
import portalvv.shared.generated.resources.compras_panel_no_reduction
import portalvv.shared.generated.resources.compras_panel_no_variation
import portalvv.shared.generated.resources.compras_panel_overview
import portalvv.shared.generated.resources.compras_panel_period_custom
import portalvv.shared.generated.resources.compras_panel_period_month
import portalvv.shared.generated.resources.compras_panel_period_year
import portalvv.shared.generated.resources.compras_panel_planned_total
import portalvv.shared.generated.resources.compras_panel_previous_total
import portalvv.shared.generated.resources.compras_panel_provisioned
import portalvv.shared.generated.resources.compras_panel_realized
import portalvv.shared.generated.resources.compras_panel_realized_total
import portalvv.shared.generated.resources.compras_panel_reduction_month
import portalvv.shared.generated.resources.compras_panel_reduction_period
import portalvv.shared.generated.resources.compras_panel_savings_value
import portalvv.shared.generated.resources.compras_panel_title
import portalvv.shared.generated.resources.compras_panel_total_increases
import portalvv.shared.generated.resources.compras_panel_total_reductions
import portalvv.shared.generated.resources.compras_panel_variation
import portalvv.shared.generated.resources.compras_refresh
import kotlin.math.abs
import kotlin.math.roundToLong

private val PANEL_TABS_MIN_WIDTH = 900.dp

private enum class PurchasesPanelTab(
    val category: PurchasesCategory?,
) {
    Overview(null),
    Proteins(PurchasesCategory.Proteins),
    Staples(PurchasesCategory.Staples),
    Dairy(PurchasesCategory.Dairy),
    Produce(PurchasesCategory.Produce),
    Chinese(PurchasesCategory.Chinese),
    Cleaning(PurchasesCategory.Cleaning),
    Disposables(PurchasesCategory.Disposables),
    Extras(PurchasesCategory.Extras),
    ;

    val label: StringResource
        get() = category?.label ?: Res.string.compras_panel_overview
}

@Composable
fun PurchasesPanelScreen() {
    val appGraph = LocalAppGraph.current
    val controller =
        remember(appGraph) {
            PurchasesPanelController(
                repository = appGraph.purchasesRepository,
                dateTimeProvider = appGraph.dateTimeProvider,
            )
        }
    val scope = rememberCoroutineScope()
    var selectedTab by remember { mutableStateOf(PurchasesPanelTab.Overview) }

    LaunchedEffect(controller) {
        controller.initialize()
    }

    LaunchedEffect(controller.selection) {
        controller.load()
    }

    BoxWithConstraints(modifier = Modifier.fillMaxSize()) {
        val panelMinHeight = (maxHeight - 160.dp).coerceAtLeast(0.dp)

        AppScrollColumn(
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(AppSpacing.space24),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            footer = { AppFooter() },
        ) {
            Text(
                text = stringResource(Res.string.compras_panel_title),
                style = MaterialTheme.typography.headlineMedium,
            )

            Surface(
                modifier = Modifier.fillMaxWidth().heightIn(min = panelMinHeight),
                shape = AppShapes.large,
                color = MaterialTheme.colorScheme.surface,
                border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
            ) {
                Column(modifier = Modifier.fillMaxWidth()) {
                    Column(
                        modifier = Modifier.fillMaxWidth().padding(AppSpacing.space12),
                        horizontalAlignment = Alignment.End,
                        verticalArrangement = Arrangement.spacedBy(AppSpacing.space8),
                    ) {
                        PeriodSelector(
                            selection = controller.selection,
                            onMode = controller::setMode,
                            onMonth = controller::selectMonth,
                            onYear = controller::selectYear,
                            onCustom = controller::selectCustom,
                            modifier = Modifier.fillMaxWidth(),
                            bordered = false,
                            modes = listOf(PeriodMode.MONTH, PeriodMode.YEAR, PeriodMode.CUSTOM),
                            modeLabels =
                                mapOf(
                                    PeriodMode.MONTH to Res.string.compras_panel_period_month,
                                    PeriodMode.YEAR to Res.string.compras_panel_period_year,
                                    PeriodMode.CUSTOM to Res.string.compras_panel_period_custom,
                                ),
                        )
                        AppButton(
                            text = stringResource(Res.string.compras_refresh),
                            onClick = { scope.launch { controller.load(keepData = true) } },
                            enabled = !controller.refreshing,
                            variant = PortalButtonVariant.Outlined,
                            leadingIcon = Lucide.RefreshCw,
                        )
                    }

                    HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)

                    PurchasesPanelTabs(
                        selectedTab = selectedTab,
                        onSelect = { selectedTab = it },
                    )

                    if (controller.error != null) {
                        AppBanner(
                            text = controller.error.orEmpty(),
                            onDismiss = controller::dismissError,
                            isError = true,
                            modifier = Modifier.padding(horizontal = AppSpacing.space16, vertical = AppSpacing.space12),
                        )
                    }

                    Column(
                        modifier =
                            Modifier
                                .fillMaxWidth()
                                .padding(AppSpacing.space16),
                    ) {
                        PanelContent(
                            controller = controller,
                            selectedTab = selectedTab,
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun PanelContent(
    controller: PurchasesPanelController,
    selectedTab: PurchasesPanelTab,
) {
    if (controller.loading && controller.data == null) {
        Box(
            modifier = Modifier.fillMaxWidth().padding(vertical = AppSpacing.space32),
            contentAlignment = Alignment.Center,
        ) {
            CircularProgressIndicator()
        }
        return
    }

    val data = controller.data
    if (data == null) {
        return
    }

    val isMonth = controller.selection.mode == PeriodMode.MONTH
    val extendedPeriod = !isMonth
    when {
        selectedTab == PurchasesPanelTab.Overview ->
            OverviewPanel(
                data = data,
                isMonth = isMonth,
                multiMonth = extendedPeriod,
                periodMonths = controller.selection.months,
                periodYear = controller.selection.endMonth.year,
            )
        selectedTab.category == PurchasesCategory.Extras -> ExtrasPanel(data, extendedPeriod)
        selectedTab.category != null ->
            key(selectedTab.category) {
                CategoryPanel(data, selectedTab.category, extendedPeriod)
            }
    }
}

@Composable
private fun OverviewPanel(
    data: PurchasesPanelData,
    isMonth: Boolean,
    multiMonth: Boolean,
    periodMonths: List<MonthPeriod>,
    periodYear: Int,
) {
    if (data.totalCents == 0L && data.plannedTotalCents == 0L && data.extrasCount == 0L) {
        PanelEmptyState()
        return
    }

    val changes =
        data.categories.mapNotNull { category ->
            if (category.totalCents <= 0L || category.previousTotalCents <= 0L) {
                null
            } else {
                category.variationPercent?.let { percent -> category to percent }
            }
        }
    val increase = changes.filter { it.second > 0 }.maxByOrNull { it.second }
    val reduction = changes.filter { it.second < 0 }.minByOrNull { it.second }
    val economyCents = data.totalCents - data.plannedTotalCents
    val economyPercent =
        if (data.plannedTotalCents == 0L) {
            null
        } else {
            economyCents.toDouble() / data.plannedTotalCents * 100.0
        }
    val economyColor =
        when {
            economyCents > 0L -> AppPalette.Error900
            economyCents < 0L -> AppPalette.Success900
            else -> MaterialTheme.colorScheme.onSurface
        }
    val economyValue = signedMoney(economyCents)
    val economyCaption = economyPercent?.let { variationText(it) } ?: NO_TABLE_VALUE

    val selectedPeriods = periodMonths.ifEmpty { data.annualCosts.map { MonthPeriod(periodYear, it.month) } }
    val monthPeriods =
        if (multiMonth) {
            activePurchaseMonths(data.categories, selectedPeriods)
        } else {
            selectedPeriods
        }
    val costsByMonth = data.annualCosts.associateBy { it.month }
    val costsByPeriod =
        monthPeriods.associateWith { period ->
            data.categories.sumOf { category ->
                category.monthly
                    .firstOrNull { it.year == period.year && it.month == period.month }
                    ?.totalCents ?: 0L
            }
        }
    val plannedByPeriod =
        if (data.periodProvisions.isNotEmpty()) {
            data.periodProvisions.associate { MonthPeriod(it.year, it.month) to it.totalCents }
        } else {
            monthPeriods.associateWith { period ->
                data.annualProvisions.firstOrNull { it.month == period.month }?.totalCents ?: 0L
            }
        }
    val spentMonths =
        monthPeriods.mapNotNull { period ->
            val cents = costsByPeriod[period] ?: 0L
            if (cents > 0L) period to cents else null
        }
    val maxSpend = spentMonths.maxByOrNull { it.second }
    val minSpend = spentMonths.minByOrNull { it.second }
    val monthVariations =
        monthPeriods.mapIndexedNotNull { index, period ->
            val cents = costsByPeriod[period] ?: 0L
            if (cents <= 0L) {
                return@mapIndexedNotNull null
            }
            val previous =
                if (index > 0) {
                    costsByPeriod[monthPeriods[index - 1]] ?: 0L
                } else if (period.year == periodYear) {
                    costsByMonth[period.month - 1]?.totalCents ?: 0L
                } else {
                    0L
                }
            if (previous <= 0L) null else period to (cents - previous) * 100.0 / previous
        }
    val maxVariation = monthVariations.maxByOrNull { it.second }
    val minVariation = monthVariations.minByOrNull { it.second }
    val monthlyAverage = if (monthPeriods.isEmpty()) 0L else data.totalCents / monthPeriods.size
    val savingsMonths =
        monthPeriods.count { period ->
            val realized = costsByPeriod[period] ?: 0L
            val planned = plannedByPeriod[period] ?: 0L
            planned > 0L && realized < planned
        }

    Column(modifier = Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
        PanelMetricRow(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.Banknote,
                            iconBackground = AppPalette.Warning100,
                            iconColor = AppPalette.Warning900,
                            label = stringResource(Res.string.compras_panel_planned_total),
                            value = money(data.plannedTotalCents),
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.ShoppingCart,
                            iconBackground = null,
                            iconColor = AppPalette.Accent900,
                            label = stringResource(Res.string.compras_panel_realized_total),
                            value = money(data.totalCents),
                            containerColor = AppPalette.Accent100,
                            labelColor = AppPalette.Accent900,
                            valueColor = AppPalette.Accent900,
                            border = null,
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.Scale,
                            iconBackground = if (economyCents > 0L) AppPalette.Error100 else AppPalette.Success100,
                            iconColor = if (economyCents > 0L) AppPalette.Error900 else AppPalette.Success900,
                            label = stringResource(Res.string.compras_panel_economy),
                            value = economyValue,
                            caption = economyCaption,
                            valueColor = economyColor,
                            valueMaxLines = 2,
                        )
                    },
                ),
        )
        if (multiMonth) {
            PanelMetricTwoColumn(
                cards =
                    listOf(
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.TrendingUp,
                                iconBackground = AppPalette.Error100,
                                iconColor = AppPalette.Error900,
                                label = stringResource(Res.string.compras_panel_month_highest_spend),
                                value = maxSpend?.first?.let(MonthCalendar::label) ?: "-",
                                caption = maxSpend?.let { money(it.second) },
                            )
                        },
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.TrendingUp,
                                iconBackground = AppPalette.Error100,
                                iconColor = AppPalette.Error900,
                                label = stringResource(Res.string.compras_panel_month_highest_variation),
                                value = maxVariation?.first?.let(MonthCalendar::label) ?: "-",
                                caption = maxVariation?.let { variationText(it.second) },
                            )
                        },
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.TrendingDown,
                                iconBackground = AppPalette.Success100,
                                iconColor = AppPalette.Success900,
                                label = stringResource(Res.string.compras_panel_month_lowest_spend),
                                value = minSpend?.first?.let(MonthCalendar::label) ?: "-",
                                caption = minSpend?.let { money(it.second) },
                            )
                        },
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.TrendingDown,
                                iconBackground = AppPalette.Success100,
                                iconColor = AppPalette.Success900,
                                label = stringResource(Res.string.compras_panel_month_lowest_variation),
                                value = minVariation?.first?.let(MonthCalendar::label) ?: "-",
                                caption = minVariation?.let { variationText(it.second) },
                            )
                        },
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.Calendar,
                                iconBackground = AppPalette.Primary100,
                                iconColor = AppPalette.Primary900,
                                label = stringResource(Res.string.compras_panel_monthly_average),
                                value = stringResource(Res.string.compras_panel_average_value, money(monthlyAverage)),
                            )
                        },
                        { modifier ->
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.Scale,
                                iconBackground = AppPalette.Success100,
                                iconColor = AppPalette.Success900,
                                label = stringResource(Res.string.compras_panel_months_with_savings),
                                value = stringResource(Res.string.compras_panel_savings_value, savingsMonths, monthPeriods.size),
                            )
                        },
                    ),
            )
        } else {
            PanelMetricRow(
                cards =
                    listOf(
                        { modifier ->
                            PanelTrendCard(
                                modifier = modifier,
                                label =
                                    stringResource(
                                        if (isMonth) {
                                            Res.string.compras_panel_increase_month
                                        } else {
                                            Res.string.compras_panel_increase_period
                                        },
                                    ),
                                change = increase,
                                positive = true,
                                emptyLabel = stringResource(Res.string.compras_panel_no_increase),
                            )
                        },
                        { modifier ->
                            PanelTrendCard(
                                modifier = modifier,
                                label =
                                    stringResource(
                                        if (isMonth) {
                                            Res.string.compras_panel_reduction_month
                                        } else {
                                            Res.string.compras_panel_reduction_period
                                        },
                                    ),
                                change = reduction,
                                positive = false,
                                emptyLabel = stringResource(Res.string.compras_panel_no_reduction),
                            )
                        },
                    ),
            )
        }

        AnnualCostChartCard(data.annualCosts)
        BudgetVsActualChartCard(
            provisions = data.annualProvisions,
            realized = data.annualCosts,
        )
        ExtrasEvolutionChartCard(data.extrasEvolution)
        CategoryCostChartCard(data.categories)
        if (multiMonth) {
            CategoryEvolutionTable(categories = data.categories, months = monthPeriods)
        } else {
            MonthlyCategoryOverviewTables(data.categories)
        }
    }
}

@Composable
private fun MonthlyCategoryPanel(
    item: PurchasesPanelCategory,
    category: PurchasesCategory,
    previousMonth: MonthPeriod?,
    currentMonth: MonthPeriod?,
) {
    val changeCents = item.totalCents - item.previousTotalCents
    val previousLabel =
        previousMonth?.let {
            stringResource(Res.string.compras_panel_category_total_in, MonthCalendar.label(it))
        } ?: stringResource(Res.string.compras_panel_previous_total)
    val currentLabel =
        currentMonth?.let {
            stringResource(Res.string.compras_panel_category_total_in, MonthCalendar.label(it))
        } ?: stringResource(Res.string.compras_panel_category_total)
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
        PanelMetricRow(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = category.icon,
                            iconBackground = category.iconBackground,
                            iconColor = category.iconColor,
                            label = previousLabel,
                            value = money(item.previousTotalCents),
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = category.icon,
                            iconBackground = null,
                            iconColor = category.iconColor,
                            label = currentLabel,
                            value = money(item.totalCents),
                            containerColor = category.iconBackground,
                            labelColor = category.iconColor,
                            valueColor = category.iconColor,
                            border = null,
                        )
                    },
                    { modifier ->
                        MonthlyVariationCard(
                            modifier = modifier,
                            icon = if (changeCents < 0L) Lucide.TrendingDown else Lucide.TrendingUp,
                            label = stringResource(Res.string.compras_panel_variation),
                            value = signedMoney(changeCents),
                            caption =
                                if (item.previousTotalCents == 0L) {
                                    NO_TABLE_VALUE
                                } else {
                                    variationText(item.variationPercent)
                                },
                            valueColor = monthlyVariationValueColor(changeCents),
                            valueMaxLines = 1,
                        )
                    },
                ),
        )
        PanelMetricRow(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingUp,
                            iconBackground = AppPalette.Error100,
                            iconColor = AppPalette.Error900,
                            label = stringResource(Res.string.compras_panel_total_increases),
                            value = money(item.totalIncreasesCents),
                        )
                    },
                    { modifier ->
                        MonthlyProductTotalChangeCard(
                            modifier = modifier,
                            label = stringResource(Res.string.compras_panel_largest_increase),
                            change = item.topIncreases.firstOrNull(),
                            positive = true,
                            emptyLabel = stringResource(Res.string.compras_panel_no_increase),
                        )
                    },
                ),
        )
        PanelMetricRow(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingDown,
                            iconBackground = AppPalette.Success100,
                            iconColor = AppPalette.Success900,
                            label = stringResource(Res.string.compras_panel_total_reductions),
                            value = money(item.totalReductionsCents),
                        )
                    },
                    { modifier ->
                        MonthlyProductTotalChangeCard(
                            modifier = modifier,
                            label = stringResource(Res.string.compras_panel_largest_reduction),
                            change = item.topReductions.firstOrNull(),
                            positive = false,
                            emptyLabel = stringResource(Res.string.compras_panel_no_reduction),
                        )
                    },
                ),
        )
        MonthlyCategoryChangesSections(
            reductions = item.topReductions,
            increases = item.topIncreases,
            previousMonth = previousMonth,
            currentMonth = currentMonth,
        )
        MonthlyProductDetailsSection(
            details = item.details,
            previousMonth = previousMonth,
            currentMonth = currentMonth,
        )
    }
}

@Composable
private fun MonthlyProductTotalChangeCard(
    modifier: Modifier = Modifier,
    label: String,
    change: PurchasesPanelProductUnitPriceChange?,
    positive: Boolean,
    emptyLabel: String,
) {
    PanelMetricCard(
        modifier = modifier,
        icon = if (positive) Lucide.TrendingUp else Lucide.TrendingDown,
        iconBackground = if (positive) AppPalette.Error100 else AppPalette.Success100,
        iconColor = if (positive) AppPalette.Error900 else AppPalette.Success900,
        label = label,
        value = change?.productName ?: emptyLabel,
        caption =
            change?.let {
                "${money(abs(it.totalChangeCents))} (${variationText(it.totalVariationPercent)})"
            },
        valueMaxLines = 2,
    )
}

@Composable
private fun MonthlyVariationCard(
    modifier: Modifier = Modifier,
    icon: ImageVector,
    label: String,
    value: String,
    caption: String? = null,
    valueColor: Color? = null,
    valueMaxLines: Int = 1,
) {
    PanelMetricCard(
        modifier = modifier,
        icon = icon,
        iconBackground = AppPalette.Neutral200,
        iconColor = AppPalette.Neutral900,
        label = label,
        value = value,
        caption = caption,
        valueColor = valueColor ?: MaterialTheme.colorScheme.onSurface,
        valueMaxLines = valueMaxLines,
    )
}

private fun monthlyVariationValueColor(change: Long): Color? =
    when {
        change < 0L -> AppPalette.Success900
        change > 0L -> AppPalette.Error900
        else -> null
    }

@Composable
private fun CategoryPanel(
    data: PurchasesPanelData,
    category: PurchasesCategory,
    extendedPeriod: Boolean,
) {
    val type = category.type
    val item = type?.let(data::category)
    if (item == null || item.totalCents == 0L) {
        PanelEmptyState()
        return
    }

    if (!extendedPeriod) {
        val currentMonth = item.monthly.firstOrNull()?.let { MonthPeriod(it.year, it.month) }
        MonthlyCategoryPanel(
            item = item,
            category = category,
            previousMonth = currentMonth?.previous(),
            currentMonth = currentMonth,
        )
        return
    }

    val months = categoryActiveMonths(item)
    val spentMonths =
        months.mapNotNull { period ->
            val cents = item.monthly.firstOrNull { it.year == period.year && it.month == period.month }?.totalCents ?: 0L
            if (cents > 0L) period to cents else null
        }
    val maxSpend = spentMonths.maxByOrNull { it.second }
    val minSpend = spentMonths.minByOrNull { it.second }
    val variations =
        months.mapIndexedNotNull { index, period ->
            if (index == 0) {
                return@mapIndexedNotNull null
            }
            val current = item.monthly.firstOrNull { it.year == period.year && it.month == period.month }?.totalCents ?: 0L
            val previousPeriod = months[index - 1]
            val previous =
                item.monthly
                    .firstOrNull { it.year == previousPeriod.year && it.month == previousPeriod.month }
                    ?.totalCents ?: 0L
            if (previous <= 0L) null else period to (current - previous) * 100.0 / previous
        }
    val maxVariation = variations.maxByOrNull { it.second }
    val minVariation = variations.minByOrNull { it.second }
    val monthlyAverage = if (months.isEmpty()) 0L else item.totalCents / months.size
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
        PanelMetricTwoColumn(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = category.icon,
                            iconBackground = null,
                            iconColor = category.iconColor,
                            label = stringResource(Res.string.compras_panel_category_total),
                            value = money(item.totalCents),
                            containerColor = category.iconBackground,
                            labelColor = category.iconColor,
                            valueColor = category.iconColor,
                            border = null,
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.Calendar,
                            iconBackground = AppPalette.Primary100,
                            iconColor = AppPalette.Primary900,
                            label = stringResource(Res.string.compras_panel_monthly_average),
                            value = stringResource(Res.string.compras_panel_average_value, money(monthlyAverage)),
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingUp,
                            iconBackground = AppPalette.Error100,
                            iconColor = AppPalette.Error900,
                            label = stringResource(Res.string.compras_panel_month_highest_spend),
                            value = maxSpend?.first?.let(MonthCalendar::label) ?: "-",
                            caption = maxSpend?.let { money(it.second) },
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingUp,
                            iconBackground = AppPalette.Error100,
                            iconColor = AppPalette.Error900,
                            label = stringResource(Res.string.compras_panel_month_highest_variation),
                            value = maxVariation?.first?.let(MonthCalendar::label) ?: "-",
                            caption = maxVariation?.let { variationText(it.second) },
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingDown,
                            iconBackground = AppPalette.Success100,
                            iconColor = AppPalette.Success900,
                            label = stringResource(Res.string.compras_panel_month_lowest_spend),
                            value = minSpend?.first?.let(MonthCalendar::label) ?: "-",
                            caption = minSpend?.let { money(it.second) },
                        )
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.TrendingDown,
                            iconBackground = AppPalette.Success100,
                            iconColor = AppPalette.Success900,
                            label = stringResource(Res.string.compras_panel_month_lowest_variation),
                            value = minVariation?.first?.let(MonthCalendar::label) ?: "-",
                            caption = minVariation?.let { variationText(it.second) },
                        )
                    },
                ),
        )
        CategoryChangesSections(
            reductions = item.topReductions,
            increases = item.topIncreases,
            months = months,
        )
        MultimonthProductDetailsSection(
            details = item.details,
            months = months,
        )
    }
}

@Composable
private fun ExtrasPanel(
    data: PurchasesPanelData,
    extendedPeriod: Boolean,
) {
    if (data.extrasCount == 0L) {
        PanelEmptyState()
        return
    }
    val variation =
        if (data.previousExtrasCount == 0L && data.extrasCount > 0L) {
            100.0
        } else {
            variationPercent(data.extrasCount, data.previousExtrasCount)
        }
    val difference = data.extrasCount - data.previousExtrasCount
    val topDirectorate = data.extrasAnalytics.directorates.firstOrNull()
    val activeExtraMonths =
        extraActiveMonths(data.extrasAnalytics.directorates, data.extrasAnalytics.months)
    val ordersByPeriod = mutableMapOf<MonthPeriod, Long>()
    data.extrasAnalytics.directorates.forEach { directorate ->
        directorate.months.forEach { month ->
            if (month.orderCount > 0L) {
                val period = MonthPeriod(month.year, month.month)
                ordersByPeriod[period] = (ordersByPeriod[period] ?: 0L) + month.orderCount
            }
        }
    }
    val topOrderPeriod = ordersByPeriod.maxByOrNull { it.value }?.toPair()
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
        PanelMetricRow(
            cards =
                listOf(
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.ShoppingCart,
                            iconBackground = AppPalette.Purple100,
                            iconColor = AppPalette.Purple900,
                            label = stringResource(Res.string.compras_panel_extras_total),
                            value = stringResource(Res.string.compras_orders, data.extrasCount.toInt()),
                        )
                    },
                    { modifier ->
                        if (extendedPeriod) {
                            PanelMetricCard(
                                modifier = modifier,
                                icon = Lucide.Calendar,
                                iconBackground = AppPalette.Purple100,
                                iconColor = AppPalette.Purple900,
                                label = stringResource(Res.string.compras_panel_extras_top_period),
                                value = topOrderPeriod?.first?.let(MonthCalendar::label) ?: "-",
                                caption =
                                    topOrderPeriod?.let {
                                        stringResource(Res.string.compras_orders, it.second.toInt())
                                    },
                                valueMaxLines = 2,
                            )
                        } else {
                            MonthlyVariationCard(
                                modifier = modifier,
                                icon = if (difference < 0L) Lucide.TrendingDown else Lucide.TrendingUp,
                                label = stringResource(Res.string.compras_panel_extras_variation),
                                value = signedDifference(difference),
                                caption = variation?.let { variationText(it) } ?: NO_TABLE_VALUE,
                                valueColor = monthlyVariationValueColor(difference),
                                valueMaxLines = 1,
                            )
                        }
                    },
                    { modifier ->
                        PanelMetricCard(
                            modifier = modifier,
                            icon = Lucide.Users,
                            iconBackground = AppPalette.Purple100,
                            iconColor = AppPalette.Purple900,
                            label = stringResource(Res.string.compras_panel_extras_top_directorate),
                            value = topDirectorate?.name ?: stringResource(Res.string.compras_panel_extras_no_directorate),
                            caption =
                                topDirectorate?.let {
                                    stringResource(Res.string.compras_orders, it.orderCount.toInt())
                                },
                            valueMaxLines = 2,
                        )
                    },
                ),
        )
        ExtrasEvolutionChartCard(data.extrasEvolution)
        ExtrasDirectorateSection(data.extrasAnalytics, activeExtraMonths)
        ExtrasReasonsSection(data.extrasAnalytics.reasons)
    }
}

private fun signedDifference(value: Long): String =
    when {
        value > 0L -> "+$value"
        else -> value.toString()
    }

@Composable
private fun PanelTrendCard(
    modifier: Modifier = Modifier,
    label: String,
    change: Pair<PurchasesPanelCategory, Double>?,
    positive: Boolean,
    emptyLabel: String,
) {
    val iconColor = if (positive) AppPalette.Error900 else AppPalette.Success900
    val iconBackground = if (positive) AppPalette.Error100 else AppPalette.Success100
    val value =
        change?.let {
            val category = PurchasesCategory.entries.firstOrNull { item -> item.type == it.first.type }
            category?.let { item -> stringResource(item.label) } ?: it.first.type.name
        } ?: emptyLabel
    val caption =
        change?.let {
            val changeCents = it.first.totalCents - it.first.previousTotalCents
            "${money(abs(changeCents))} (${variationText(it.second)})"
        }
    val valueColor =
        when {
            change == null -> MaterialTheme.colorScheme.onSurface
            positive -> AppPalette.Error900
            else -> AppPalette.Success900
        }
    PanelMetricCard(
        modifier = modifier,
        icon = if (positive) Lucide.TrendingUp else Lucide.TrendingDown,
        iconBackground = iconBackground,
        iconColor = iconColor,
        label = label,
        value = value,
        caption = caption,
        valueColor = valueColor,
        valueMaxLines = 2,
    )
}

@Composable
private fun PanelMetricRow(cards: List<@Composable (Modifier) -> Unit>) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        if (maxWidth >= 900.dp) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                cards.forEach { card ->
                    Box(modifier = Modifier.weight(1f)) {
                        card(Modifier.fillMaxWidth())
                    }
                }
            }
        } else {
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
                cards.forEach { card -> card(Modifier.fillMaxWidth()) }
            }
        }
    }
}

@Composable
private fun PanelMetricTwoColumn(cards: List<@Composable (Modifier) -> Unit>) {
    Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space12)) {
        cards.chunked(2).forEach { rowCards ->
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
            ) {
                rowCards.forEach { card ->
                    Box(modifier = Modifier.weight(1f)) {
                        card(Modifier.fillMaxWidth())
                    }
                }
                if (rowCards.size == 1) {
                    Spacer(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun PanelMetricCard(
    modifier: Modifier = Modifier,
    icon: ImageVector,
    iconBackground: Color?,
    iconColor: Color,
    label: String,
    value: String,
    caption: String? = null,
    valueMaxLines: Int = 1,
    containerColor: Color = MaterialTheme.colorScheme.surface,
    labelColor: Color = MaterialTheme.colorScheme.onSurfaceVariant,
    valueColor: Color = MaterialTheme.colorScheme.onSurface,
    border: BorderStroke? = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
) {
    Surface(
        modifier = modifier.heightIn(min = 88.dp),
        shape = AppShapes.large,
        color = containerColor,
        border = border,
    ) {
        Row(
            modifier = Modifier.padding(AppSpacing.space16),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            if (iconBackground == null) {
                Icon(
                    imageVector = icon,
                    contentDescription = null,
                    tint = iconColor,
                    modifier = Modifier.size(32.dp),
                )
            } else {
                Surface(
                    modifier = Modifier.size(48.dp),
                    shape = AppShapes.medium,
                    color = iconBackground,
                ) {
                    Box(contentAlignment = Alignment.Center) {
                        Icon(
                            imageVector = icon,
                            contentDescription = null,
                            tint = iconColor,
                            modifier = Modifier.size(24.dp),
                        )
                    }
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space4)) {
                Text(
                    text = label,
                    style = MaterialTheme.typography.bodySmall,
                    color = labelColor,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis,
                )
                Text(
                    text = value,
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.SemiBold,
                    color = valueColor,
                    maxLines = valueMaxLines,
                    overflow = TextOverflow.Ellipsis,
                )
                if (caption != null) {
                    Text(
                        text = caption,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                }
            }
        }
    }
}

@Composable
private fun PanelEmptyState() {
    Box(modifier = Modifier.fillMaxWidth().height(360.dp)) {
        EmptyState(message = stringResource(Res.string.compras_panel_empty))
    }
}

@Composable
private fun PurchasesPanelTabs(
    selectedTab: PurchasesPanelTab,
    onSelect: (PurchasesPanelTab) -> Unit,
) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        if (maxWidth >= PANEL_TABS_MIN_WIDTH) {
            PrimaryTabRow(selectedTabIndex = PurchasesPanelTab.entries.indexOf(selectedTab)) {
                PurchasesPanelTab.entries.forEach { tab ->
                    Tab(
                        selected = tab == selectedTab,
                        onClick = { onSelect(tab) },
                        text = { Text(text = stringResource(tab.label)) },
                    )
                }
            }
        } else {
            PrimaryScrollableTabRow(selectedTabIndex = PurchasesPanelTab.entries.indexOf(selectedTab)) {
                PurchasesPanelTab.entries.forEach { tab ->
                    Tab(
                        selected = tab == selectedTab,
                        onClick = { onSelect(tab) },
                        text = { Text(text = stringResource(tab.label)) },
                    )
                }
            }
        }
    }
}

@Composable
private fun AnnualCostChartCard(points: List<PurchasesPanelMonthlyCost>) {
    ChartCard(title = stringResource(Res.string.compras_panel_chart_annual_cost)) {
        if (points.all { it.totalCents == 0L }) {
            ChartEmpty()
        } else {
            val displayedPoints = points.reversed()
            val labels = displayedPoints.map { shortMonthLabel(it.month) }
            val values = displayedPoints.map { it.totalCents / 100f }
            XYGraph(
                gridStyle = NoGridStyle,
                xAxisModel = rememberValueAxis(values.maxOrNull() ?: 0f, headroom = 1.2f),
                yAxisModel = CategoryAxisModel(labels),
                xAxisContent =
                    rememberAxisContent(
                        title = { Text(stringResource(Res.string.compras_panel_axis_cost), style = MaterialTheme.typography.labelSmall) },
                        labels = { value -> Text(compactMoney((value * 100).roundToLong()), style = MaterialTheme.typography.labelSmall) },
                    ),
                yAxisContent = rememberAxisContent(labels = { label -> Text(label, style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height((points.size * 40 + 48).dp),
            ) {
                HorizontalBarPlot(
                    xData = values,
                    yData = labels,
                    barWidth = 0.6f,
                    bar = { index, _, _ ->
                        val point = displayedPoints.getOrNull(index)
                        val cents = point?.totalCents ?: 0L
                        HoverTooltip(text = "${labels.getOrNull(index).orEmpty()}: ${money(cents)}") {
                            ValueBar(
                                color = AppPalette.Primary500,
                                label = money(cents),
                                horizontal = true,
                            )
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun BudgetVsActualChartCard(
    provisions: List<PurchasesPanelMonthlyCost>,
    realized: List<PurchasesPanelMonthlyCost>,
) {
    ChartCard(title = stringResource(Res.string.compras_panel_chart_budget_actual)) {
        if (
            provisions.all { it.totalCents == 0L } &&
            realized.all { it.totalCents == 0L }
        ) {
            ChartEmpty()
        } else {
            val points = realized.ifEmpty { provisions }
            val labels = points.map { shortMonthLabel(it.month) }
            val provisionValues =
                labels.indices.map { index ->
                    (provisions.getOrNull(index)?.totalCents ?: 0L) / 100f
                }
            val realizedValues =
                labels.indices.map { index ->
                    (realized.getOrNull(index)?.totalCents ?: 0L) / 100f
                }
            val maxValue = (provisionValues + realizedValues).maxOrNull() ?: 0f
            val data =
                labels.mapIndexed { index, label ->
                    DefaultBarPlotGroupedPointEntry(
                        i = label,
                        d =
                            listOf(
                                DefaultBarPosition(0f, provisionValues[index]),
                                DefaultBarPosition(0f, realizedValues[index]),
                            ),
                    )
                }
            val provisionedLabel = stringResource(Res.string.compras_panel_provisioned)
            val realizedLabel = stringResource(Res.string.compras_panel_realized)
            Column(verticalArrangement = Arrangement.spacedBy(AppSpacing.space8)) {
                Row(horizontalArrangement = Arrangement.spacedBy(AppSpacing.space16)) {
                    ChartLegendItem(AppPalette.Warning500, provisionedLabel)
                    ChartLegendItem(AppPalette.Primary500, realizedLabel)
                }
                XYGraph(
                    gridStyle = NoGridStyle,
                    xAxisModel = CategoryAxisModel(labels),
                    yAxisModel = rememberValueAxis(maxValue, headroom = 1.2f),
                    xAxisContent = rememberAxisContent(labels = { label -> Text(label, style = MaterialTheme.typography.labelSmall) }),
                    yAxisContent =
                        rememberAxisContent(
                            title = { Text(stringResource(Res.string.compras_panel_axis_cost), style = MaterialTheme.typography.labelSmall) },
                            labels = { value -> Text(compactMoney((value * 100).roundToLong()), style = MaterialTheme.typography.labelSmall) },
                        ),
                    modifier = Modifier.fillMaxWidth().height(280.dp),
                ) {
                    GroupedVerticalBarPlot(
                        data = data,
                        maxBarGroupWidth = 0.6f,
                        bar = { _, seriesIndex, value ->
                            val seriesValue = value.d.getOrNull(seriesIndex)?.end ?: 0f
                            val tooltip =
                                buildString {
                                    append(value.i)
                                    append('\n')
                                    append(provisionedLabel)
                                    append(": ")
                                    append(money((provisionValues.getOrNull(labels.indexOf(value.i)) ?: 0f).times(100).roundToLong()))
                                    append('\n')
                                    append(realizedLabel)
                                    append(": ")
                                    append(money((realizedValues.getOrNull(labels.indexOf(value.i)) ?: 0f).times(100).roundToLong()))
                                }
                            HoverTooltip(text = tooltip) {
                                ValueBar(
                                    color = if (seriesIndex == 0) AppPalette.Warning500 else AppPalette.Primary500,
                                    label = compactMoney((seriesValue * 100).roundToLong()),
                                    horizontal = false,
                                )
                            }
                        },
                    )
                }
            }
        }
    }
}

@Composable
private fun ChartLegendItem(
    color: Color,
    label: String,
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(AppSpacing.space4),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Box(Modifier.size(10.dp).background(color, AppShapes.small))
        Text(
            text = label,
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}

@Composable
private fun ExtrasEvolutionChartCard(points: List<PurchasesPanelMonthlyCount>) {
    ChartCard(title = stringResource(Res.string.compras_panel_chart_extras_evolution)) {
        if (points.all { it.orderCount == 0L }) {
            ChartEmpty()
        } else {
            val labels = points.map { shortMonthLabel(it.month) }
            val values = points.map { it.orderCount.toFloat() }
            val axis = rememberValueAxis(values.maxOrNull() ?: 0f, headroom = 1.35f)
            XYGraph(
                gridStyle = NoGridStyle,
                xAxisModel = CategoryAxisModel(labels),
                yAxisModel = axis,
                xAxisContent = rememberAxisContent(labels = { label -> Text(label, style = MaterialTheme.typography.labelSmall) }),
                yAxisContent =
                    rememberAxisContent(
                        title = { Text(stringResource(Res.string.compras_panel_axis_orders), style = MaterialTheme.typography.labelSmall) },
                        labels = { value -> Text(value.roundToLong().toString(), style = MaterialTheme.typography.labelSmall) },
                    ),
                modifier = Modifier.fillMaxWidth().height(240.dp),
            ) {
                LinePlot(
                    data = labels.indices.map { index -> Point(labels[index], values[index]) },
                    lineStyle = LineStyle(brush = SolidColor(AppPalette.Purple900), strokeWidth = 2.dp),
                    symbol = { point ->
                        val count = point.y.roundToLong()
                        HoverTooltip(text = "$count pedidos") {
                            LinePointLabel(count.toString(), AppPalette.Purple900)
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun CategoryCostChartCard(categories: List<PurchasesPanelCategory>) {
    ChartCard(title = stringResource(Res.string.compras_panel_chart_categories)) {
        val entries = categories.filter { it.totalCents > 0L }.sortedByDescending { it.totalCents }
        if (entries.isEmpty()) {
            ChartEmpty()
        } else {
            val namesByType = mutableMapOf<PurchasesType, String>()
            PurchasesCategory.entries.forEach { category ->
                val type = category.type ?: return@forEach
                namesByType[type] = stringResource(category.label)
            }
            val ordered = entries.reversed()
            val names = ordered.map { namesByType[it.type] ?: it.type.name }
            val values = ordered.map { it.totalCents / 100f }
            XYGraph(
                gridStyle = NoGridStyle,
                xAxisModel = rememberValueAxis(entries.maxOf { it.totalCents } / 100f, headroom = 1.15f),
                yAxisModel = CategoryAxisModel(names),
                xAxisContent =
                    rememberAxisContent(
                        title = { Text(stringResource(Res.string.compras_panel_axis_cost), style = MaterialTheme.typography.labelSmall) },
                        labels = { value -> Text(compactMoney((value * 100).roundToLong()), style = MaterialTheme.typography.labelSmall) },
                    ),
                yAxisContent = rememberAxisContent(labels = { name -> Text(name, style = MaterialTheme.typography.labelSmall) }),
                modifier = Modifier.fillMaxWidth().height((entries.size * 44 + 48).dp),
            ) {
                HorizontalBarPlot(
                    xData = values,
                    yData = names,
                    barWidth = 0.6f,
                    bar = { index, _, _ ->
                        val category = ordered.getOrNull(index)
                        val cents = category?.totalCents ?: 0L
                        val categoryUi =
                            PurchasesCategory.entries.firstOrNull { it.type == category?.type }
                        HoverTooltip(text = "${names.getOrNull(index) ?: ""}: ${money(cents)}") {
                            ValueBar(
                                color = categoryUi?.iconColor ?: AppPalette.Primary500,
                                label = money(cents),
                                horizontal = true,
                            )
                        }
                    },
                )
            }
        }
    }
}

@Composable
private fun ChartEmpty() {
    Text(
        text = stringResource(Res.string.compras_panel_no_data),
        style = MaterialTheme.typography.bodyMedium,
        color = MaterialTheme.colorScheme.onSurfaceVariant,
    )
}

private fun shortMonthLabel(month: Int): String =
    listOf("Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez")
        .getOrElse(month - 1) { month.toString() }

private fun variationPercent(
    current: Long,
    previous: Long,
): Double? = if (previous == 0L) null else (current - previous).toDouble() / previous.toDouble() * 100.0

@Composable
internal fun variationText(value: Double?): String {
    if (value == null) return stringResource(Res.string.compras_panel_no_variation)
    val formatted = PercentFormatter.format(value)
    return when {
        value > 0 -> "+$formatted%"
        else -> "$formatted%"
    }
}

internal fun money(cents: Long): String = "R$ ${MoneyFormatter.formatCents(cents)}"
